<span *ngIf="content?.length <= limit">{{ content }}</span>
<span *ngIf="content?.length > limit">
  <span *ngIf="readMore" class="me-2">{{ content }}</span>
  <span *ngIf="!readMore" class="me-2">{{ content | slice:0:limit }}&hellip;</span>
  <span
    class="btn-link fw-bold d-inline-block"
    style="cursor: pointer;"
    (click)="readMore = !readMore">
    {{ readMore ? 'read less' : 'read more' }}
  </span>
</span>
